import { NgModule } from "@angular/core";

import { BitIconButtonComponent } from "./icon-button.component";

@NgModule({
  imports: [BitIconButtonComponent],
  exports: [BitIconButtonComponent],
})
export class IconButtonModule {}
